import {Component} from '@angular/core';

@Component({
  selector: 'app-reservation-edit',
  templateUrl: './reservation-edit.component.html',
  styleUrls: ['./reservation-edit.component.scss'],
  standalone: false,
})
export class ReservationEditComponent {}
